import { CurrencyCodes } from "Infrastructure/Api/Api";

const CURRENCY_STORAGE_KEY = "vivelo_currency";

const VALID_CURRENCIES = new Set(Object.values(CurrencyCodes));

export function getSavedCurrency(): CurrencyCodes {
  const saved = localStorage.getItem(CURRENCY_STORAGE_KEY);
  if (saved && VALID_CURRENCIES.has(saved as CurrencyCodes)) {
    return saved as CurrencyCodes;
  }
  return CurrencyCodes.EUR;
}

export function saveCurrencyPreference(currency: CurrencyCodes): void {
  localStorage.setItem(CURRENCY_STORAGE_KEY, currency);
}
